module.exports = __webpack_public_path__ + "img/DSC_0180 teatro beto.c146933c.jpg";